import { CSSProperties } from 'react';

export interface SubNavItem<Id extends string> {
  id: Id;
  label: string;
  danger?: boolean;
}

const nav: CSSProperties = {
  flex: '0 0 190px',
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  position: 'sticky',
  top: 16,
  alignSelf: 'flex-start',
};

const backgroundFor = (active: boolean, danger?: boolean): string => {
  if (!active) return 'transparent';
  return danger ? 'var(--bui-bg-danger)' : 'var(--bui-bg-neutral-2)';
};

const colorFor = (active: boolean, danger?: boolean): string => {
  if (danger) return 'var(--bui-fg-danger)';
  return active ? 'var(--bui-fg-primary)' : 'var(--bui-fg-secondary)';
};

const entryStyle = (active: boolean, danger?: boolean): CSSProperties => ({
  textAlign: 'left',
  padding: '8px 12px',
  borderRadius: 6,
  border: 'none',
  cursor: 'pointer',
  fontSize: 13.5,
  fontWeight: active ? 600 : 400,
  width: '100%',
  background: backgroundFor(active, danger),
  color: colorFor(active, danger),
});

export const SubNav = <Id extends string>({
  items,
  active,
  onSelect,
  label = 'Manage sections',
}: {
  items: SubNavItem<Id>[];
  active: Id;
  onSelect: (id: Id) => void;
  label?: string;
}) => (
  <nav style={nav} aria-label={label}>
    {items.map(entry => (
      <button
        key={entry.id}
        type="button"
        style={entryStyle(active === entry.id, entry.danger)}
        aria-current={active === entry.id ? 'true' : undefined}
        onClick={() => onSelect(entry.id)}
      >
        {entry.label}
      </button>
    ))}
  </nav>
);
